/**
 * Forget everything the previous user's session loaded (B-06). Query keys carry no user id, so
 * without this a sign-out → sign-in as someone else in the same tab showed the old inbox, Sent and
 * Drafts until each query refetched. Called on logout and on every successful sign-in.
 * Import-free (the caller passes the client and the store reset) so it is testable under node.
 */
export function resetClientState(
  queryClient: { cancelQueries: () => unknown; clear: () => void },
  stores: { resetMail: () => void },
): void {
  queryClient.cancelQueries();
  queryClient.clear();
  stores.resetMail();
}
